import { MeasurementSystem } from '../types/MeasurementSystem';
import { capacitanceConverter } from './capacitance';
import { chargeConverter } from './charge';
import { currentConverter } from './current';
import { currentSlewRateConverter } from './current-slew-rate';
import { digitalConverter } from './digital';
import { efficiencyConverter } from './efficiency';
import { energyConverter } from './energy';
import { frequencyConverter } from './frequency';
import { i2tConverter } from './i2t';
import { InductancePerUnitLengthConverter, InductancePerUnitLengthUnits, inductanceConverter } from './inductance';
import { LengthConverter, LengthUnits } from './length';
import { MassConverter, MassUnits } from './mass';
import { powerConverter } from './power';
import { ResistancePerUnitLengthConverter, ResistancePerUnitLengthUnits, resistanceConverter } from './resistance';
import { TemperatureConverter } from './temperature';
import { temperatureCoefficientConverter } from './temperature-coefficient';
import { ThermalResistivityConverter } from './thermal-resistivity';
import { timeConverter } from './time';
import { UnitConverter } from './types';
import { voltageConverter } from './voltage';

const TEMPERATURE_STORAGE_UNITS = ['K'] as const;

const thermalResistivityConverter = new ThermalResistivityConverter();

type ConverterFactory = (measurementSystem: MeasurementSystem) => UnitConverter<any, any>;

const CONVERTER_FACTORIES: [readonly string[], ConverterFactory][] = [
    [capacitanceConverter.units, () => capacitanceConverter],
    [chargeConverter.units, () => chargeConverter],
    [currentConverter.units, () => currentConverter],
    [currentSlewRateConverter.units, () => currentSlewRateConverter],
    [digitalConverter.units, () => digitalConverter],
    [efficiencyConverter.units, () => efficiencyConverter],
    [energyConverter.units, () => energyConverter],
    [frequencyConverter.units, () => frequencyConverter],
    [i2tConverter.units, () => i2tConverter],
    [inductanceConverter.units, () => inductanceConverter],
    [powerConverter.units, () => powerConverter],
    [resistanceConverter.units, () => resistanceConverter],
    [temperatureCoefficientConverter.units, () => temperatureCoefficientConverter],
    [thermalResistivityConverter.units, () => thermalResistivityConverter],
    [timeConverter.units, () => timeConverter],
    [voltageConverter.units, () => voltageConverter],
    [InductancePerUnitLengthUnits, (system) => new InductancePerUnitLengthConverter(system)],
    [LengthUnits, (system) => new LengthConverter(system)],
    [MassUnits, (system) => new MassConverter(system)],
    [ResistancePerUnitLengthUnits, (system) => new ResistancePerUnitLengthConverter(system)],
    [TEMPERATURE_STORAGE_UNITS, (system) => new TemperatureConverter(system)],
];

const CONVERTER_FACTORIES_BY_UNIT = new Map<string, ConverterFactory>(
    CONVERTER_FACTORIES.flatMap(([units, factory]) => units.map((unit) => [unit, factory] as const)),
);

export const getConverterByUnit = (unit: string, measurementSystem: MeasurementSystem) => {
    return CONVERTER_FACTORIES_BY_UNIT.get(unit)?.(measurementSystem) ?? null;
};
